
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { Item } from '@view/a-pedido-cargar/controlador-pedido';
    import articulos from './articulos/articulos.vue';
    import cantidad from './cantidad/cantidad.vue';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Articulo } from '@/__env/lib/Articulos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            articulos,
            cantidad,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.EdicionPedido; }
        public get Items() { return this.Controlador.EdicionPedido.Items; }
        public get Modo() { return this.Controlador.Vista.BarraIzquierda.Modo; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

        Eliminar( item: Item )
        {
            this.Controlador.EdicionPedido.NuevoItem.Eliminar( item );
        }

    }
